import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { profileQueries } from './queries';

export function useProfile() {
  const { group = '' } = useParams();

  const { data, isPending } = useQuery(profileQueries.detail(group));

  return {
    profile: data ?? null,
    isLoading: isPending,
  };
}
